export default __webpack_public_path__ + "static/play-rule-app-ec1fb31ae3c7e3e6a4b982b85c4551c5.png";